var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css } from "styled-components";
import { useCombobox } from "downshift";
import { InputText } from "../InputText";
/**
 * This component is meant to support partial searches, where the search query is not identical to any of the options.
 * For example, a user wants to specify `startsWith` for device names and also wants to see a list of the devices.
 */
export const Typeahead = (props) => {
    const { disabled, readOnly, name, options, width = "100%", value, onChange, filter } = props;
    const filteredOptions = options.filter((option) => filter(value, option));
    const { getInputProps, isOpen, getItemProps, getMenuProps } = useCombobox({
        initialInputValue: value,
        items: filteredOptions,
        onInputValueChange: ({ inputValue }) => {
            onChange(inputValue);
        },
    });
    return (React.createElement(Container, { width: width },
        React.createElement(InputText, Object.assign({}, getInputProps(), { disabled: disabled, readOnly: readOnly, name: name, width: width })),
        React.createElement(List, Object.assign({}, getMenuProps(), { isOpen: isOpen && !readOnly }), isOpen &&
            !readOnly &&
            filteredOptions.map((item, index) => (React.createElement(ListItem, Object.assign({ key: `${item}${index}` }, getItemProps({ index, item })), item))))));
};
const Container = styled.div `
  position: relative;
  width: ${({ width }) => width};
`;
const List = styled.ul `
  margin: 0;
  padding: 0;
  overflow: hidden;
  border-radius: 4px;
  list-style-type: none;

  ${({ theme, isOpen }) => isOpen &&
    css `
      background-color: ${theme.colors.inputColors.dropDownBackground};
      box-shadow: ${theme.shadows.searchBox.simpleShadow};
      box-sizing: border-box;
      max-height: 300px;
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1;
    `};
`;
const ListItem = styled.li `
  ${({ theme }) => css `
    background-color: ${theme.colors.inputColors.dropDownOptionBackground};
    box-sizing: border-box;
    color: ${theme.colors.inputColors.dropDownOptionText};
    cursor: default;
    display: block;
    font-size: inherit;
    padding: 8px 12px;
    user-select: none;
    width: 100%;
  `}

  ${(_a) => {
    var { theme } = _a, remainingProps = __rest(_a, ["theme"]);
    return remainingProps["aria-selected"] &&
        css `
      background-color: ${theme.colors.inputColors.dropDownOptionFocusedBackground};
      color: ${theme.colors.inputColors.dropDownOptionFocused};
    `;
}}
`;
